<template>
    <div class="index page_home">
		111111111
    </div>
</template>

<script>
    export default {
        // name: 'home-index',
        data() {
            return {
            }
        },
        created () {
            // console.log(this.$publicData)
        },
        methods: {
            // 点击轮播图
            swiper_img_click(item) {
                console.log(item)
                // this.$router.push(`/m/count`)
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>